function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 172",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    style: {
      fill: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.507 10.779-23.291 10.75v129l23.291 10.75m102.983-150.5 23.293 10.75v129l-23.292 10.75",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#7a7a7a",
      strokeWidth: 10.74999046,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 192V0h192v192z",
    transform: "translate(14.333 14.333) scale(.74653)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa726"
    },
    d: "M48 100c-11.047 0-20-8.953-20-20s8.953-20 20-20 20 8.953 20 20-8.953 20-20 20",
    transform: "translate(14.333 14.333) scale(.74653)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546e7a"
    },
    d: "M8.125 132.422S19.078 108 48 108s40.125 24.422 40.125 24.422L88 148H8ZM184 132s-11.078-24-40-24-40 24-40 24v16h80z",
    transform: "translate(14.333 14.333) scale(.74653)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfd8dc"
    },
    d: "M120 64c0 13.266-10.75 24-24 24S72 77.266 72 64s10.75-24 24-24 24 10.75 24 24m24 64s-13.547-27.781-48.266-27.781C61.031 100.219 48 128 48 128v20h96z",
    transform: "translate(14.333 14.333) scale(.74653)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa726"
    },
    d: "M144 100c11.047 0 20-8.953 20-20s-8.953-20-20-20-20 8.953-20 20 8.953 20 20 20",
    transform: "translate(14.333 14.333) scale(.74653)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa726"
    },
    d: "M48 100c-11.047 0-20-8.953-20-20s8.953-20 20-20 20 8.953 20 20-8.953 20-20 20m96 0c11.047 0 20-8.953 20-20s-8.953-20-20-20-20 8.953-20 20 8.953 20 20 20",
    transform: "translate(14.333 14.333) scale(.74653)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientPool);
export default __webpack_public_path__ + "static/media/clientPool.e82c58661e48c578e73584777c86c5c1.svg";
export { ForwardRef as ReactComponent };